/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SendPriority {
  Lowest = 0,
  VeryLow = 1,
  Low = 2,
  Normal = 3,
  AboveNormal = 4,
  High = 5,
  VeryHigh = 6,
  Highest = 7
}
